function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareStepCTA = void 0;
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _images = require("../../images");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactNative = require("react-native-web");
var _STYLES = require("../../styles/STYLES");
var _CopyLink = require("./CopyLink");
var _HaveDoneCounter = require("./HaveDoneCounter");
var _useLang = require("./useLang");
var _SocialMediaButtons = require("./SocialMediaButtons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ShareStepCTA = exports.ShareStepCTA = (0, _react.memo)(function (_ref) {
  var _navigator;
  var stepName = _ref.stepName,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    url = _ref.url,
    _ref$counter = _ref.counter,
    counter = _ref$counter === void 0 ? 0 : _ref$counter;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _STYLES.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  var _share = {
    title: stepName || t('shareStepCTA:title'),
    url: url,
    text: text
  };
  var isWeb = _reactNative.Platform.OS === 'web';
  var showSingleShareButton = !isWeb || isWeb && ((_navigator = navigator) == null ? void 0 : _navigator.canShare == null ? void 0 : _navigator.canShare(_share));
  var nativeShareStepAction = function nativeShareStepAction() {
    if (isWeb) {
      navigator.share(_share);
    } else {
      _reactNative.Share == null ? void 0 : _reactNative.Share.share({
        message: _share.text,
        url: _share.url,
        title: _share.title
      });
    }
  };
  var ShareIcon = (0, _react.memo)(function () {
    return (0, _jsxRuntime.jsx)(Icons.Share, {
      color: COLORS.white,
      size: _STYLES.STYLES.fontSize.l,
      style: [styles.shareIconStyle]
    });
  });
  return (0, _jsxRuntime.jsxs)(_reactNative.View, {
    style: [styles.card],
    testID: "ShareStepCTA",
    children: [(0, _jsxRuntime.jsx)(_images.SkateboardWithSpeechBubble, {
      style: [styles.bigImage]
    }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: [styles.content],
      children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: [styles.cta],
        children: [(0, _jsxRuntime.jsx)(_images.Skateboard, {
          style: [styles.smallImage]
        }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: [styles.textContainer],
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: [styles.title],
            children: t('shareStepCTA:title')
          }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: [styles.explanation],
            children: t('shareStepCTA:explanation')
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
        children: [!showSingleShareButton && (0, _jsxRuntime.jsx)(_CopyLink.CopyLink, {
          url: url,
          style: [styles.copyLink]
        }), showSingleShareButton && (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.shareStepButton],
          children: (0, _jsxRuntime.jsx)(_Button.Button, {
            type: _Button.ButtonType.icon,
            containerStyle: [styles.shareStepButtonContainer],
            textStyle: [styles.shareStepButtonText],
            onPress: nativeShareStepAction,
            icon: ShareIcon,
            label: t('shareStepCTA:shareThisStep'),
            children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.shareStepButtonInnerText,
              children: t('shareStepCTA:shareThisStep')
            })
          })
        }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: styles.counterIcons,
          children: [(0, _jsxRuntime.jsx)(_HaveDoneCounter.HaveDoneCounter, {
            count: counter,
            style: [styles.counter]
          }), !showSingleShareButton && (0, _jsxRuntime.jsx)(_SocialMediaButtons.SocialMediaButtons, {
            style: styles.socialButtons,
            shareable: {
              text: text,
              url: url
            }
          })]
        })]
      })]
    })]
  });
});